export default "/static/dashboard/build/app/img/v2/1a0c9995a2424f5d38935ad12bd83eac.png";